import { resolveByGeofips } from './crosswalk';

export const CALIFORNIA_STATE_GEOFIPS = 6;

export type MunicipalReportBlockReason = 'ok' | 'missing' | 'state' | 'not_incorporated_city';

export function municipalReportEligibility(geofips: number | null | undefined): {
  eligible: boolean;
  reason: MunicipalReportBlockReason;
} {
  if (geofips == null) {
    return { eligible: false, reason: 'missing' };
  }
  const n = typeof geofips === 'number' ? geofips : Number(geofips);
  if (!Number.isFinite(n)) {
    return { eligible: false, reason: 'missing' };
  }
  if (n === CALIFORNIA_STATE_GEOFIPS) {
    return { eligible: false, reason: 'state' };
  }
  const entry = resolveByGeofips(n);
  if (!entry || !entry.inPopulationCity || entry.populationGeofips == null) {
    return { eligible: false, reason: 'not_incorporated_city' };
  }
  return { eligible: true, reason: 'ok' };
}

export function isMunicipalReportEligible(geofips: number | null | undefined): boolean {
  return municipalReportEligibility(geofips).eligible;
}
